import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import About from "@/components/About";
import WhatWeDo from "@/components/WhatWeDo";
import FocusAreas from "@/components/FocusAreas";
import Philosophy from "@/components/Philosophy";
import ApplyForm from "@/components/ApplyForm";
import Partners from "@/components/Partners";
import Footer from "@/components/Footer";

function Landing() {
  useEffect(() => {
    document.documentElement.classList.add("dark");
    document.body.style.backgroundColor = "#000000";
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className="App grain min-h-screen bg-black text-white">
      <Header />
      <main>
        <Hero
          onApply={() => scrollTo("apply")}
          onPartner={() => scrollTo("partners")}
        />
        <About />
        <WhatWeDo />
        <FocusAreas />
        <Philosophy />
        <ApplyForm />
        <Partners />
        <Footer />
      </main>
      <Toaster
        position="bottom-center"
        theme="dark"
        toastOptions={{
          style: {
            background: "#0a0a0a",
            color: "#ffffff",
            border: "1px solid #1f1f1f",
            borderRadius: 0,
            fontFamily: "Manrope, sans-serif",
            letterSpacing: "0.05em",
          },
        }}
      />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
